import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouteDataService } from 'src/app/pages/custom-route/shared/map/services/route-data.service';
import { PlannerSelectedDayStateService } from 'src/app/pages/custom-route/shared/planner/services';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { ScrollService } from 'src/app/services/scroll.service';

@Component({
  selector: 'app-actions-buttons-compact',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './actions-buttons-compact.component.html',
  styleUrls: ['./actions-buttons-compact.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ActionsButtonsCompactComponent {
  public startRouteClick = output();
  public editRouteClick = output();
  public buyTicketsClick = output();
  
  private _breakpointsService = inject(BreakpointsService);
  private _scrollService = inject(ScrollService);
  private _plannerSelectedDayStateService = inject(PlannerSelectedDayStateService);
  private _routeDataService = inject(RouteDataService);
  
  private readonly _selectedDate = computed(() => this._plannerSelectedDayStateService.selectedDate());
  private readonly _isScrolled = computed(() => this._scrollService.isScrolled());
  get isScrolled() {
    return this._isScrolled();
  }
  private readonly _isMobile = computed(() => this._breakpointsService.isMobile());
  
  public handleStartRouteClick() {
    this.startRouteClick.emit();
  }
  
  public handleEditRouteClick() {
    this.editRouteClick.emit();
  }
  
  public handleBuyTicketsClick() {
    this.buyTicketsClick.emit();
  }
  
  getLabelTransportPayment(): string {
    return this._isMobile() ? 'Transporte' : 'Acceso transporte';
  }

  isActionsButtonsDisabled(){
    return this._routeDataService.isYesterdayOrOlder(this._selectedDate());
  }
}
